import { render, staticRenderFns } from "./DataFormat.vue?vue&type=template&id=2db8c4b7&scoped=true"
import script from "./DataFormat.vue?vue&type=script&lang=js"
export * from "./DataFormat.vue?vue&type=script&lang=js"
import style0 from "./DataFormat.vue?vue&type=style&index=0&id=2db8c4b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db8c4b7",
  null
  
)

export default component.exports